import React from 'react';

const ShopSidebar = ({
  categories = [],
  loadingCategories,
  activeCategories = [],
  onCategoryToggle,
  onClearFilters
}) => {
  return (
    <aside className="shop-sidebar">
      <div className="sidebar-filter-group">
        <h3 className="filter-title">Categories</h3>
        {loadingCategories ? (
          <div className="sidebar-loading">Loading categories...</div>
        ) : categories.length === 0 ? (
          <div className="sidebar-no-items">No categories found</div>
        ) : (
          <ul className="filter-list">
            <li
              className={activeCategories.length === 0 ? 'active' : ''}
              onClick={() => {
                if (activeCategories.length > 0) {
                  // Toggle off all currently selected categories
                  activeCategories.forEach(catName => onCategoryToggle(catName));
                }
              }}
            >
              <input
                type="checkbox"
                checked={activeCategories.length === 0}
                onChange={() => {}} // onClick on parent li handles it
                className="filter-checkbox"
              />
              <span>All Categories</span>
            </li>
            {categories.map((cat) => {
              const isChecked = activeCategories.includes(cat.name);
              return (
                <li
                  key={cat.name}
                  className={isChecked ? 'active' : ''}
                  onClick={() => onCategoryToggle(cat.name)}
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => {}} // onClick on parent li handles it
                    className="filter-checkbox"
                  />
                  <span>{cat.displayName || cat.name}</span>
                </li>
              );
            })}
          </ul>
        )}
      </div>

      <button onClick={onClearFilters} className="btn-clear-filters">
        Clear All Filters
      </button>
    </aside>
  );
};

export default ShopSidebar;
